// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function AdminLogin() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({ email: "", password: "" });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleLogin = (e) => {
//     e.preventDefault();

//     // Hardcoded Admin Login
//     if (form.email === "admin" && form.password === "admin123") {
//       const adminUser = {
//         id: 0,
//         username: "Admin",
//         email: "admin",
//         role: "ADMIN",
//       };

//       // STORE admin like normal user login
//       localStorage.setItem("user", JSON.stringify(adminUser));

//       alert("Admin Login Successful!");

//       navigate("/admin/manage-rooms");
//       return;
//     }

//     alert("Invalid Admin Credentials");
//   };

//   return (
//     <div className="login-container">
//       <form className="login-card" onSubmit={handleLogin}>
//         <h2>Admin Login</h2>

//         <input
//           type="text"
//           name="email"
//           placeholder="Admin Username"
//           value={form.email}
//           onChange={handleChange}
//           required
//         />

//         <input
//           type="password"
//           name="password"
//           placeholder="Admin Password"
//           value={form.password}
//           onChange={handleChange}
//           required
//         />

//         <button type="submit">Login</button>
//       </form>
//     </div>
//   );
// }


//***********ADMIN LOGIN UI DESIGN 6/1/26 ********/

// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";

// export default function AdminLogin() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({ email: "", password: "" });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleLogin = (e) => {
//     e.preventDefault();

//     // Hardcoded Admin Login
//     if (form.email === "admin" && form.password === "admin123") {
//       const adminUser = {
//         id: 0,
//         username: "Admin",
//         email: "admin",
//         role: "ADMIN",
//       };

//       localStorage.setItem("user", JSON.stringify(adminUser));

//       alert("Admin Login Successful!");
//       navigate("/admin/manage-rooms");
//       return;
//     }

//     alert("Invalid Admin Credentials");
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center vh-100 bg-light">
//       <div className="card shadow-lg p-4" style={{ width: "420px" }}>
//         <div className="text-center mb-3">
//           <h3 className="fw-bold text-danger">🔐 Admin Panel</h3>
//           <p className="text-muted">Authorized access only</p>
//         </div>

//         <form onSubmit={handleLogin}>
//           <div className="mb-3">
//             <label className="form-label fw-semibold">Admin Username</label>
//             <input
//               type="text"
//               className="form-control"
//               name="email"
//               placeholder="Enter admin username"
//               value={form.email}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="mb-3">
//             <label className="form-label fw-semibold">Password</label>
//             <input
//               type="password"
//               className="form-control"
//               name="password"
//               placeholder="Enter admin password"
//               value={form.password}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <button className="btn btn-danger w-100 fw-bold mt-2">
//             Login as Admin
//           </button>
//         </form>

//         <div className="text-center mt-3">
//           <small>
//             Back to{" "}
//             <Link to="/login" className="fw-semibold">
//               User Login
//             </Link>
//           </small>
//         </div>
//       </div>
//     </div>
//   );
// }


import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("http://localhost:8080/api/auth/login", form);

      if (res.data.role !== "ADMIN") {
        alert("You are not an admin");
        return;
      }

      localStorage.setItem("user", JSON.stringify(res.data));
      navigate("/admin/dashboard", { replace: true });

    } catch (err) {
      alert("Invalid admin credentials");
    }
  };

  return (
    <form onSubmit={handleLogin}>
      <input name="email" onChange={handleChange} placeholder="Email" />
      <input name="password" type="password" onChange={handleChange} placeholder="Password" />
      <button>Admin Login</button>
      <Link to="/login">User Login</Link>
    </form>
  );
}
